import { render, staticRenderFns } from "./MarkdownContent.vue?vue&type=template&id=6fefd7ea&"
import script from "./MarkdownContent.vue?vue&type=script&lang=js&"
export * from "./MarkdownContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports